import React, { useState, useEffect } from "react";
import article from "../../assets/article.png";
import card_membership from "../../assets/card_membership.png";
import Group from "../../assets/Group.png";
import Password from "../../assets/Password.png";
import transaction from "../../assets/transaction.png";
import Avatar from "../../assets/Avatar.png";
import profile from "../../assets/home/profile.png";
import { Tab, Nav, Col, Row } from 'react-bootstrap';
import ProfileModal from "../../components/profile/modals/profileModal";
import Transaction from "../../components/profile/components/Transaction";
import SubscriptionModal from "../../components/profile/modals/SubscriptionModal";
import TransactionModal from "../../components/profile/modals/TransactionModal";
import FeedbackModal from "../../components/profile/modals/FeedbackModal";
import FaqModal from "../../components/profile/modals/FaqModal";
import { GetLearner } from "../../redux/actions/AuthAction";
import { useDispatch } from "react-redux";
import { initGA, initPixel } from "../../helpers/CampaignEvents";
import Subscription from "../../components/profile/components/Subscription";
import FeedbackComp from "../../components/profile/components/FeedbackComp";
import Notifications from "../../components/profile/components/Notifications";
import DeleteAccModal from "../../components/profile/modals/DeleteAccModal";


const Account = () => {
  const dispatch = useDispatch();
  const [modalShow, setModalShow] = useState(false);
  const [subModalShow, setsubModalShow] = useState(false);
  const [tranModalShow, settranModalShow] = useState(false);
  const [feedbackModalShow, setfeedbackModalShow] = useState(false);
  const [faqModalShow, setfaqModalShow] = useState(false);
  const data = JSON.parse(localStorage.getItem('USER'));
  const subscribe = JSON.parse(localStorage.getItem("SUBSCRIBED"));
  console.log(data.phoneNumber)

  useEffect(() => {

    initPixel()
    initGA()

    if (subscribe) {
      dispatch(GetLearner({ phoneNumber: data.phoneNumber }));
      window.location.reload();
      localStorage.removeItem("SUBSCRIBED");
    }
  }, []);

  return (
    <>
      <div className="learner_account pt-2 pb-4">
        {/* <hr className="line"/> */}
        <div className="content">
          {/* New Profile design */}

          <div className="side-tab">
            <Tab.Container id="left-tabs-example" defaultActiveKey="first">
              <Row>
                <div className="horizontal"></div>
                <Col sm={3} className="mt-5">
                  <Nav variant="pills" className="flex-column">
                    <Nav.Item >
                      <Nav.Link eventKey="first">Profile</Nav.Link>
                    </Nav.Item>
                    <Nav.Item className="mt-3">
                      <Nav.Link eventKey="second">Subscription History</Nav.Link>
                    </Nav.Item>
                    <Nav.Item className="mt-3">
                      <Nav.Link eventKey="third">Transactions</Nav.Link>
                    </Nav.Item>
                    <Nav.Item className="mt-3">
                      <Nav.Link eventKey="fourth">Notifications</Nav.Link>
                    </Nav.Item>
                    <Nav.Item className="mt-3">
                      <Nav.Link eventKey="fifth">Feedback</Nav.Link>
                    </Nav.Item>

                  </Nav>

                </Col>
                <Col sm={1}>
                  <div className="vertical"></div>
                </Col>
                <Col sm={8} className="mt-5">
                  <Tab.Content>
                    <Tab.Pane eventKey="first">
                      <div className="card">
                        <div className="row">
                          <div className="col-md-6">
                            <div>
                              <p className="top mb-0">Name</p>
                              <p className="bottom">
                                {data.name ? data.name : "N/A"}
                              </p>
                            </div>
                            <div >
                              <p className="top mb-0">Number</p>
                              <p className="bottom">
                                {data.phoneNumber ? data.phoneNumber : "N/A"}
                              </p>
                            </div>
                            <div >
                              <p className="top mb-0">Email</p>
                              <p className="bottom">
                                {data.email ? data.email : "N/A"}
                              </p>
                            </div>
                            <div >
                              <p className="top mb-0">City</p>
                              <p className="bottom">
                                {data.city ? data.city : "N/A"}
                              </p>
                            </div>
                            <div >
                              <p className="top mb-0">Profession</p>
                              <p className="bottom">
                                {data.profession ? data.profession : "N/A"}
                              </p>
                            </div>

                            <div >
                              <DeleteAccModal userId={data._id}/>
                            </div>

                          </div>
                          <div className="col-md-6">
                            <img width="190px" src={profile} />
                          </div>
                        </div>


                      </div>
                    </Tab.Pane>
                    <Tab.Pane eventKey="second">
                      <Subscription />
                    </Tab.Pane>
                    <Tab.Pane eventKey="third">
                      <Transaction />
                    </Tab.Pane>
                    <Tab.Pane eventKey="fourth">
                      <Notifications />
                    </Tab.Pane>
                    <Tab.Pane eventKey="fifth">
                      <FeedbackComp />
                    </Tab.Pane>

                  </Tab.Content>
                </Col>
              </Row>
            </Tab.Container>
          </div>
          {/* New profile design ends */}

          <div className="mobile-view">
            <h4 className="text-center">Profile</h4>
            <div className="profile_Card  mb-3 mx-auto ">
              <div className="row">
                <div className="col-md-6 mt-md-0  d-md-flex">
                  {/* <img
                    style={{ width: "128px", height: "128px" }}
                    className="ml-4 mt-4 my-auto"
                    src={Avatar}
                    alt="avatar"
                  /> */}
                 
                </div>
                <div className="col-md-6 ">
                  <div className="ml-4 card">
                    <div>
                      <p className="top mb-0">Name</p>
                      <p className="bottom">
                        {data.name ? data.name : "N/A"}
                      </p>
                    </div>
                    <div >
                      <p className="top mb-0">Number</p>
                      <p className="bottom">
                        {data.phoneNumber ? data.phoneNumber : "N/A"}
                      </p>
                    </div>
                    <div >
                      <p className="top mb-0">Email</p>
                      <p className="bottom">
                        {data.email ? data.email : "N/A"}
                      </p>
                    </div>
                    <div >
                      <p className="top mb-0">City</p>
                      <p className="bottom">
                        {data.city ? data.city : "N/A"}
                      </p>
                    </div>
                    <div >
                      <p className="top mb-0">Profession</p>
                      <p className="bottom">
                        {data.profession ? data.profession : "N/A"}
                      </p>
                    </div>
                    <div><DeleteAccModal userId={data._id}/></div>
                  </div>
                </div>
              </div>
              <div>
                {/* <div
                  id="changepassid"
                  className="small_card d-flex justify-content-around mt-5 pt-2"
                  onClick={() => setModalShow(true)}
                >
                  <div className="col-md-4 col-2">
                    <img className="pb-1 ml-3" src={Password} />
                  </div>
                  <div className="col-md-6 col-8"><span className="my-auto">Change Password</span></div>
                  <div className="col-md-2 col-1"><span className="left_margin">
                    {">"}
                  </span></div>

                </div> */}

                <div
                  id="subbuttonid"
                  className="small_card d-flex justify-content-around mt-2 pt-2"
                  onClick={() => setsubModalShow(true)}
                >
                  <div className="col-md-4 col-2">
                    <img className="pb-1 ml-3" src={card_membership} />
                  </div>
                  <div style={{color:"#24a791"}}  className="col-md-6 col-8 pt-2"><span className="my-auto">Subscription History</span></div>
                  <div style={{color:"#24a791"}}  className="col-md-2 col-1 pt-2"><span className="left_margin">
                    {">"}
                  </span></div>


                </div>
                <div
                  id="tranid"
                  className="small_card d-flex justify-content-around mt-2 pt-2"
                  onClick={() => settranModalShow(true)}
                >
                  <div className="col-md-4 col-2">
                    <img className="pb-1 ml-3" src={transaction} />
                  </div>
                  <div style={{color:"#24a791"}} className="col-md-6 col-8 pt-2"><span className="my-auto">Your Transactions</span></div>
                  <div style={{color:"#24a791"}} className="col-md-2 col-1 pt-2"><span className="left_margin">
                    {">"}
                  </span></div>
                </div>
                <div id="faqid" className="small_card d-flex justify-content-around mt-2 pt-2" onClick={() => setfaqModalShow(true)}>
                  <div className="col-md-4 col-2">
                    <img className="pb-1 ml-3" src={Group} />
                  </div>
                  <div style={{color:"#24a791"}}  className="col-md-6 col-8 pt-2"><span className="my-auto">Notifications</span></div>
                  <div style={{color:"#24a791"}}  className="col-md-2 col-1 pt-2"><span className="left_margin">
                    {">"}
                  </span></div>
                </div>
                <div
                  id="feedbackid"
                  className="small_card d-flex justify-content-around mt-2 pt-2"
                  onClick={() => setfeedbackModalShow(true)}
                >
                  <div className="col-md-4 col-2">
                    <img className="pb-1 ml-3" src={article} />
                  </div>
                  <div style={{color:"#24a791"}}  className="col-md-6 col-8 pt-2"><span className="my-auto">Feedback</span></div>
                  <div style={{color:"#24a791"}}  className="col-md-2 col-1 pt-2"><span className="left_margin">
                    {">"}
                  </span></div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
      {/* MODALS */}
      <ProfileModal show={modalShow} onHide={() => setModalShow(false)} />
      <SubscriptionModal
        show={subModalShow}
        onHide={() => setsubModalShow(false)}
      />
      <TransactionModal
        show={tranModalShow}
        onHide={() => settranModalShow(false)}
      />
      <FeedbackModal
        show={feedbackModalShow}
        onHide={() => setfeedbackModalShow(false)}
      />
      <FaqModal
        show={faqModalShow}
        onHide={() => setfaqModalShow(false)}
      />
    </>
  );
};

export default Account;
